import React, { useState, useEffect } from "react";
import authService from "../services/authService";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";
import "./Auth.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Register() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [message, setMessage] = useState("");
  const [showResend, setShowResend] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setFormData({ name: "", email: "", password: "", confirmPassword: "" });
    setMessage("");
    setShowResend(false);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validarSenha = (senha) => {
    const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%])[A-Za-z\d!@#$%]{8,16}$/;
    return regex.test(senha);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setMessage("❌ As senhas não coincidem.");
      return;
    }

    if (!validarSenha(formData.password)) {
      setMessage(
        "❌ A senha deve conter entre 8 e 16 caracteres, incluindo letras, números e um caractere especial (!@#$%)."
      );
      return;
    }

    try {
      const response = await authService.register({
        name: formData.name,
        email: formData.email,
        password: formData.password,
      });
      setMessage(response.data.message);
      
      setShowResend(false);
    } catch (error) {
     const errMsg = error.response?.data?.error || "Erro ao registrar usuário";
setMessage(errMsg);

// Verificação mais ampla para capturar variações da mensagem
if (errMsg.toLowerCase().includes("email") && errMsg.toLowerCase().includes("registr")) {
  
  console.log(">>> setShowResend acionado com mensagem:", errMsg);

  setShowResend(true);
}

    }
  };

  const handleResend = async () => {
    try {
      const response = await axios.post("/api/auth/resend-confirmation", {
        email: formData.email,
      });
      setMessage(response.data.message);
      setShowResend(false);
    } catch (error) {
      setMessage(error.response?.data?.error || "Erro ao reenviar confirmação");
    }
  };

  return (
    <AppLayout>
      <div className="auth-container">
        <h2>📝 Registrar</h2>
        <form onSubmit={handleSubmit} autoComplete="off" className="auth-form">
          <input type="text" name="fakeusernameremembered" style={{ display: "none" }} />
          <input type="password" name="fakepasswordremembered" style={{ display: "none" }} />

          <input
            type="text"
            name="name"
            placeholder="Digite seu nome completo"
            autoComplete="new-name"
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Insira aqui o seu e-mail"
            autoComplete="new-email"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="password"
            name="password"
            placeholder="Crie uma senha segura"
            autoComplete="new-password"
            value={formData.password}
            onChange={handleChange}
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirme sua senha"
            autoComplete="new-password"
            value={formData.confirmPassword}
            onChange={handleChange}
          />

          <p className="senha-requisitos">
            A senha deve conter entre 8 e 16 caracteres. É obrigatório incluir
            letras, números e um caractere especial (!@#$%).
          </p>

          <button type="submit" className="auth-button">Registrar</button>
        </form>

        {message && <p className="auth-message">{message}</p>}

        {showResend && (
          <div className="auth-actions">
            <button onClick={handleResend} className="auth-button secondary">
              Reenviar link de confirmação
            </button>
            <button onClick={() => navigate("/forgot-password")} className="auth-button secondary">
              Redefinir senha
            </button>
          </div>
        )}
      </div>
      <Footer />
    </AppLayout>
  );
}

export default Register;
